export default function Marquee({ items }) {
  const text = items.join("   ·   ") + "   ·   ";
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-obsidian-2">
      <div className="marquee-track py-4">
        {[0, 1].map((half) => (
          <span
            key={half}
            aria-hidden={half === 1}
            className="shrink-0 whitespace-nowrap font-condensed text-xl md:text-2xl font-medium uppercase tracking-[0.18em] text-slate-400"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
